import InboxReminderType from 'owa-service/lib/contract/InboxReminderType';

export default function isNewReminder(
    reminderToCheck: InboxReminderType,
    existingReminders: InboxReminderType[]
): boolean {
    if (!existingReminders) {
        // If there is no reminder set, the draft reminder is new
        return true;
    }

    // The draft reminder is a new reminder if it's not present in the existing reminders list
    const remindersWithMatchingIds = existingReminders.filter(
        reminder => reminder.Id === reminderToCheck.Id
    );
    return remindersWithMatchingIds.length === 0;
}
